import React from 'react';
import { Query } from '@apollo/client/react/components';
import LoadingProgress from 'lib/react-router/loading-progress';
import ErrorPage from 'four-nets/errors/error-page';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import Group from './group/group';
import newGroupsQuery, { NewGroupsQuery, NewGroupsQueryVariables } from './new-groups.graphql';
import defaultStyles from './new-groups.scss';
import SkeletonGroup from './skeleton-group/skeleton-group';

export interface Props {
    styles: typeof defaultStyles;
}

class NewGroups extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.container}>
                <h2 className={styles.newGroupsHeader}>
                    <FormattedMessage id='NEW_GROUPS' />
                </h2>
                <Query<NewGroupsQuery, NewGroupsQueryVariables>
                    query={newGroupsQuery}
                    variables={{
                        first: 3,
                    }}
                >
                    {({ loading, error, data }) => (
                        <LoadingProgress loading={loading}>
                            <ErrorPage error={error}>
                                <ul className={styles.groups}>
                                    {loading
                                        ? [1, 2, 3].map(index => (
                                              <li className={styles.group} key={index}>
                                                  <SkeletonGroup key={index} />
                                              </li>
                                          ))
                                        : data && data.groups && data.groups.edges
                                        ? data.groups.edges.map((edge, index) =>
                                              edge && edge.node ? (
                                                  <li className={styles.group} key={index}>
                                                      <Group {...edge.node} key={index} />
                                                  </li>
                                              ) : null
                                          )
                                        : null}
                                </ul>
                            </ErrorPage>
                        </LoadingProgress>
                    )}
                </Query>
            </div>
        );
    }
}

export default Styled(defaultStyles)(NewGroups);
